import axiosInstance from "../../../utils/axios";

const commonPath= "common";

export const GlobalSettingsDetails = async () => {
  return await axiosInstance().get(`${commonPath}/global-settings`);
};
export const CMSPageDetails = async (slug, type = "website") => {
  return await axiosInstance().get(`${commonPath}/cms-page?slug=${slug}&type=${type}`);
};
export const FAQList = async (type = "website") => {
  return await axiosInstance().get(`${commonPath}/faq?type=${type}`);
};
export const postContactUs = async (data) => {
  return await axiosInstance().post(`${commonPath}/contact-us`, data);
};
